const footerLinks = {
  快速导航: [
    { label: '热门黑料', href: '#cards' },
    { label: '瓜田合集', href: '#index' },
    { label: '重磅专题', href: '#carousel' },
    { label: '热度榜单', href: '#ranking' },
    { label: '实拍视频', href: '#media' },
  ],
  帮助中心: [
    { label: '常见问题', href: '#faq' },
    { label: '爆料投稿', href: '#contact' },
    { label: '手机访问', href: '#app' },
    { label: '关于我们', href: '#about' },
  ],
};

export default function Footer() {
  const handleLinkClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-950 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-fire-fill text-background-50 text-lg"></i>
              </div>
              <span className="text-lg font-bold text-background-50 font-heading whitespace-nowrap">
                五一黑料网
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              五一黑料网汇聚全网最新黑料吃瓜、今日黑料与瓜田爆料内幕，热点瓜视频实时更新。提供五一黑料入口、网站官网最新地址，确保您随时随地畅快吃瓜。
            </p>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-semibold text-background-100 mb-4 font-heading">
                {title}
              </h4>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      onClick={(e) => { e.preventDefault(); handleLinkClick(link.href); }}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4 font-heading">
              合作伙伴
            </h4>
            <p className="text-sm text-background-500 leading-relaxed">
              诚邀优质内容平台与媒体机构加入合作。如有合作意向，请通过爆料投稿渠道与我们取得联系。
            </p>
          </div>
        </div>

        <div className="border-t border-background-800/60 mt-10 pt-8">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; {new Date().getFullYear()} 五一黑料网 wuyiheiliao.com. All Rights Reserved.
            </p>
            <div className="flex items-center gap-4 text-xs text-background-500">
              <span className="cursor-pointer hover:text-primary-400 transition-colors whitespace-nowrap">用户协议</span>
              <span className="cursor-pointer hover:text-primary-400 transition-colors whitespace-nowrap">隐私政策</span>
              <span className="cursor-pointer hover:text-primary-400 transition-colors whitespace-nowrap">免责声明</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}